const CustomNavPrev = () => {
	return (
		<span className="icon-button-arrow-prev"></span>
	);
}

export default CustomNavPrev;